import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import ProductInventory from "../components/products/inventory/productInventory";



const InventoryStack = () => {
    const AppStack = createStackNavigator()

    return (
        <AppStack.Navigator
            initialRouteName={"ProductInventory"}
            screenOptions={{ headerShown: false }}>
            <AppStack.Screen name="ProductInventory" component={ProductInventory} />
        </AppStack.Navigator>
    )
}
export default InventoryStack
